/* ==========================================================================
   Bundle-Konfigurator — Logik (Paket A / Task A2)
   Spec: docs/2026-08-31-bundle-konfigurator-design.md
   Plan: docs/2026-08-31-bundle-konfigurator-plan.md

   Zustaendig fuer: Auswahl-State, Live-Preise, GRATIS-Badge, Event
   `moonou:bundle-change`, ATC (EIN POST /cart/add.js im Gift-Picker-Muster)
   und die anschliessende Rabattcode-Anwendung.

   GENERISCH: kein Produkt-, Bundle- oder Marken-Sonderfall im Code. Alles
   kommt aus dem JSON-Blob der Section (A1). Der einzige "Sonderfall" —
   Babou hat die Leuchte inklusive — wird DATENGETRIEBEN erkannt: kostet die
   Mit-Leuchte-Variante genauso viel wie die Ohne-Leuchte-Variante, zeigt die
   Karte den Hinweis "Leuchte inklusive". Kein Handle im Code.

   RABATT-MECHANIK (am 31.08. empirisch am Bestand verifiziert, Vorbild
   `assets/cart.js` ~572 `cart-discount`):
     POST {{ routes.cart_update_url }}  ->  /cart/update.js
     Body: { "discount": "CODE1,CODE2", "sections": ["<id>"] }
     Antwort: vollstaendiger Cart + `discount_codes: [{code, applicable}]`
     Messung gegen den Dev-Server (Cart mit Finn 49,99):
       {"discount":"5EUR"}          -> applicable:true,  total 4999 -> 4499
       {"discount":"WELCOME5"}      -> applicable:false, total bleibt 4999
       {"discount":""}              -> discount_codes: []  (Reset)
     Mehrere Codes werden akzeptiert; nicht kombinierbare kommen mit
     applicable:false zurueck — gemessen am 31.08.:
       {"discount":"5EUR,SOMMER-BUNDLE"} -> [{5EUR,true},{SOMMER-BUNDLE,false}]
       Gesamtsumme unveraendert, der Bundle-Rabatt faellt KOMPLETT weg.
     Bundle-Codes sind bewusst nicht kombinierbar (Spec §5). Deshalb faehrt
     applyDiscount() bei applicable:false einen ZWEITEN Versuch nur mit dem
     Bundle-Code und sagt dem Kunden, dass sein alter Code dafuer entfernt
     wurde; scheitert auch das, wird der Ausgangszustand wiederhergestellt.
     Ein "wird an der Kasse angewendet" gibt es nicht mehr: was Shopify hier
     mit applicable:false ablehnt, lehnt auch der Checkout ab.

   Konventionen dieser Datei: kein `?.`/`??` (verschluckt Fehlzustaende),
   Fehler immer als console.warn('[bundle] …').
   ========================================================================== */

(function () {
  'use strict';

  var LOG = '[bundle] ';
  var MONEY_FALLBACK_FORMAT = '{{amount_with_comma_separator}} €';
  var NOTICE_AUTO_MISSING = 'Ein Gratis-Artikel ist derzeit nicht verfügbar und entfällt.';
  var TEXT_SOLD_OUT = 'Ausverkauft';
  var TEXT_PICK_COLOR = 'Bitte wählen';

  /* ------------------------------------------------------------------ */
  /* Hilfsfunktionen                                                     */
  /* ------------------------------------------------------------------ */

  function warn(message, extra) {
    if (typeof extra === 'undefined') {
      console.warn(LOG + message);
    } else {
      console.warn(LOG + message, extra);
    }
  }

  /** Preis in Cent -> Shop-Waehrungsformat. Nutzt den Theme-Formatter,
   *  faellt sonst auf deutsches Format zurueck (nie stumm scheitern). */
  function money(cents) {
    var value = parseInt(cents, 10);
    if (isNaN(value)) {
      warn('money() ohne gueltigen Betrag aufgerufen: ' + cents);
      value = 0;
    }
    var format = MONEY_FALLBACK_FORMAT;
    if (window.theme && theme.settings && typeof theme.settings.moneyFormat === 'string' && theme.settings.moneyFormat !== '') {
      format = theme.settings.moneyFormat;
    }
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      try {
        return theme.Currency.formatMoney(value, format);
      } catch (error) {
        warn('theme.Currency.formatMoney fehlgeschlagen — eigener Fallback.', error);
      }
    }
    var euros = (value / 100).toFixed(2).split('.');
    var whole = euros[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');
    return whole + ',' + euros[1] + ' €';
  }

  /**
   * Wort aus einem Anzeigenamen streichen ("Cora Lampenschirm" -> "Cora").
   * Rein kosmetisch: Produkt- und Variantenzuordnung laufen ueber Handles und
   * IDs, nie ueber diesen Text. Doppelte Leerzeichen fallen mit weg, damit ein
   * Wort auch mitten im Namen entfernt werden kann.
   */
  function stripWord(title, word) {
    if (typeof title !== 'string') return '';
    if (typeof word !== 'string' || word === '') return title;
    return title.split(word).join(' ').replace(/\s+/g, ' ').trim();
  }

  /**
   * Zusammenfassungszeile eines Slots nach dem Muster der Schirm-Buybox
   * ("{name} Lampe {farbe}" -> "Cora Lampe Rosa"). Ohne Muster bleibt der
   * Name allein stehen; ohne Farbe faellt der Farb-Platzhalter weg.
   */
  function formatChosen(pattern, name, color) {
    if (typeof pattern !== 'string' || pattern === '') {
      if (typeof color === 'string' && color !== '') return name + ' · ' + color;
      return name;
    }
    var text = pattern
      .split('{name}').join(name)
      .split('{farbe}').join(typeof color === 'string' ? color : '');
    return text.replace(/\s+/g, ' ').trim();
  }

  function normalize(value) {
    if (typeof value !== 'string') return '';
    return value.trim().toLowerCase();
  }

  /** Optionswert einer Variante an Position 1..3. */
  function optionAt(variant, position) {
    if (position === 1) return variant.option1;
    if (position === 2) return variant.option2;
    if (position === 3) return variant.option3;
    return null;
  }

  /**
   * Verfuegbarkeit EINER Variante. Der JSON-Blob der Section liefert das
   * Feld `available` je Variante; fehlt es, gilt die Variante als NICHT
   * verfuegbar — lieber eine Karte zu viel sperren als einen ATC mit
   * "Cannot find variant" gegen die Wand fahren (der /cart/add.js-Call ist
   * atomar: EINE ausverkaufte Zeile kippt das gesamte Bundle).
   */
  function variantAvailable(variant) {
    if (variant === null || typeof variant !== 'object') return false;
    if (typeof variant.available !== 'boolean') {
      warn('Variante ohne available-Feld (' + variant.id + ') — wird als ausverkauft behandelt.');
      return false;
    }
    return variant.available === true;
  }

  /** Hat Shopify DIESEN Code wirklich angewendet? `applicable:false` ist ein
   *  Nein — auch der Checkout wendet ihn dann nicht an. */
  function discountApplied(cartJson, code) {
    if (cartJson === null || typeof cartJson !== 'object') return false;
    if (!(cartJson.discount_codes instanceof Array)) return false;
    for (var i = 0; i < cartJson.discount_codes.length; i++) {
      var entry = cartJson.discount_codes[i];
      if (typeof entry.code === 'string' &&
          entry.code.toUpperCase() === code.toUpperCase() &&
          entry.applicable === true) {
        return true;
      }
    }
    return false;
  }

  function findVariantById(product, id) {
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === String(id)) return product.variants[i];
    }
    return null;
  }

  function findProductByHandle(products, handle) {
    for (var i = 0; i < products.length; i++) {
      if (products[i].handle === handle) return products[i];
    }
    return null;
  }

  /**
   * Variante ueber Optionswerte bestimmen: Ausgangspunkt ist die
   * Standardvariante des Produkts; Farb- und Leuchten-Position werden
   * ueberschrieben, alle anderen Optionen (z. B. "Anzahl") bleiben stehen.
   * Findet sich keine exakte Kombination, bleibt die Standardvariante —
   * mit Warnung, nie stumm.
   */
  function resolveVariant(product, wantedColor, wantedBulbValue) {
    var base = findVariantById(product, product.default_variant_id);
    if (base === null) {
      if (product.variants.length === 0) {
        warn('Produkt ohne Varianten: ' + product.handle);
        return null;
      }
      base = product.variants[0];
    }

    var target = [base.option1, base.option2, base.option3];
    var colorPos = product.color_option_position;
    var bulbPos = product.bulb_option_position;

    if (colorPos > 0 && typeof wantedColor === 'string' && wantedColor !== '') {
      target[colorPos - 1] = wantedColor;
    }
    if (bulbPos > 0 && typeof wantedBulbValue === 'string' && wantedBulbValue !== '') {
      target[bulbPos - 1] = wantedBulbValue;
    }

    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (normalize(v.option1) === normalize(target[0]) &&
          normalize(v.option2) === normalize(target[1]) &&
          normalize(v.option3) === normalize(target[2])) {
        return v;
      }
    }

    warn('Keine Variante fuer ' + product.handle + ' mit [' + target.join(' / ') + '] — Standardvariante bleibt.');
    return base;
  }

  /** Variante eines Produkts, bei der irgendeine Option dem gesuchten
   *  Wert entspricht (Muster der auto_item-Zuordnung aus A1). */
  function resolveVariantByOptionValue(product, wantedValue) {
    var wanted = normalize(wantedValue);
    if (wanted !== '') {
      var firstMatch = null;
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        if (normalize(v.option1) === wanted || normalize(v.option2) === wanted || normalize(v.option3) === wanted) {
          /* Eine VERFUEGBARE Treffervariante hat Vorrang: sonst faellt der
             Gratis-Artikel wegen einer ausverkauften Nebenvariante weg,
             obwohl es die gesuchte Farbe lieferbar gibt. */
          if (variantAvailable(v)) return v;
          if (firstMatch === null) firstMatch = v;
        }
      }
      if (firstMatch !== null) return firstMatch;
    }
    var fallback = findVariantById(product, product.default_variant_id);
    if (fallback === null && product.variants.length > 0) fallback = product.variants[0];
    if (wanted !== '') {
      warn('Keine Variante "' + wantedValue + '" bei ' + product.handle + ' — Standardvariante beigelegt.');
    }
    return fallback;
  }

  /** Kostet die Mit-Leuchte-Variante dasselbe wie die Ohne-Leuchte-Variante,
   *  ist die Leuchte im Produkt inklusive (Babou-Fall — datengetrieben). */
  function bulbIsIncluded(product) {
    if (product.bulb_option_position === 0) return false;
    if (product.bulb_on_value === '' || product.bulb_off_value === '') return false;
    var off = resolveVariant(product, null, product.bulb_off_value);
    var on = resolveVariant(product, null, product.bulb_on_value);
    if (off === null || on === null) return false;
    return off.price === on.price;
  }

  /* ------------------------------------------------------------------ */
  /* Custom Element                                                      */
  /* ------------------------------------------------------------------ */

  /* Custom Elements verlangen ein echtes `class` (kein ES5-Konstruktor). */
  class BundleConfigurator extends HTMLElement {
    constructor() {
      super();
      this.config = null;
      this.onChangeBound = this.onChange.bind(this);
      this.onClickBound = this.onClick.bind(this);
      this.onScrollBound = this.onScroll.bind(this);
      this.onResizeBound = this.onResize.bind(this);
      this.onBundleChangeBound = this.onBundleChange.bind(this);
      this.onPointerDownBound = this.onPointerDown.bind(this);
      this.onKeydownBound = this.onKeydown.bind(this);
      this.onFocusOutBound = this.onFocusOut.bind(this);
      this.busy = false;
      /* Kam die letzte Auswahl von Maus/Finger? Nur dann klappt der Slot
         sofort zu — per Tastatur wuerde das die fokussierte Karte wegreissen. */
      this.pointerSelect = false;
      /* v3.2 — Slots, die ihren Erstdurchlauf hinter sich haben (Index -> true).
         Ein solcher Slot klappt NIE mehr von selbst zu: weder bei einer neuen
         Auswahl noch beim Fokusverlust. Nur Kopf/"Aendern" schliesst ihn.
         Das Auto-Zuklappen samt Auto-Weiter gilt allein beim Erstdurchlauf. */
      this.slotDone = {};
      /* Zaehler fuer den Galerie-Crossfade: schuetzt ein laufendes Ausblenden
         davor, ein bereits gestartetes naechstes Overlay abzuraeumen. */
      this.galleryToken = 0;
      this.galleryTimer = 0;
      this.galleryGhostEl = null;
      /* Zustand der CTA-Freischaltung beim letzten Render (null = noch nie). */
      this.ctaWasReady = null;
      /* Galerie: welcher Slot liegt gerade als Hauptbild vorn (Slot-Index,
         null = noch keine Auswahl -> Serverbild bleibt stehen). */
      this.galleryIndex = null;
      this.galleryFallbackSrc = '';
      this.galleryFallbackEl = null;
      this.galleryFrameEl = null;
      /* Laufende rAF-Anforderung der Slider-Neuvermessung (0 = keine). */
      this.scrollFrame = 0;
      this.lastData = null;
    }

    connectedCallback() {
      /* Kein Element-Caching ueber Editor-Reloads: bei jedem connect neu
         lesen, weil `shopify:section:load` das Markup komplett ersetzt. */
      this.config = this.readConfig();
      if (this.config === null) return;

      this.totalEl = this.querySelector('[data-bundle-total]');
      this.compareEl = this.querySelector('[data-bundle-compare]');
      this.percentEl = this.querySelector('[data-bundle-percent]');
      this.noticeEl = this.querySelector('[data-bundle-notice]');
      this.atcEl = this.querySelector('[data-bundle-atc]');
      this.bulbEl = this.querySelector('[data-bundle-bulb]');

      /* v3: GRATIS-Box unter dem letzten Slot. Optional — fehlt sie, laeuft
         der Rest unveraendert weiter. */
      this.gratisBoxEl = this.querySelector('[data-bundle-gratis-box]');
      this.gratisListEl = this.querySelector('[data-bundle-gratis-list]');
      this.gratisPlaceholderEl = this.querySelector('[data-bundle-gratis-placeholder]');

      /* v2: Fortschritt, Accordion-Koepfe und Live-Galerie. Alle drei sind
         optional — fehlt einer, laeuft der Rest weiter (die Preis-/ATC-
         Mechanik haengt an keinem davon). */
      this.progressEl = this.querySelector('[data-bundle-progress]');
      this.progressDoneEl = this.querySelector('[data-bundle-progress-done]');
      this.progressTotalEl = this.querySelector('[data-bundle-progress-total]');
      this.progressFillEl = this.querySelector('[data-bundle-progress-fill]');
      this.galleryEl = this.querySelector('[data-bundle-gallery]');
      this.galleryMainEl = null;
      /* Rahmen der statischen Galerie — traegt --m-bundle-gallery-ratio. */
      this.galleryFrameEl = null;
      /* v3: Statische Galerie. Sie haengt an KEINER Auswahl — das JS wechselt
         dort nur das Hauptbild, renderGallery() haelt sich komplett heraus. */
      this.galleryStatic = this.galleryEl !== null &&
        this.galleryEl.getAttribute('data-gallery-mode') === 'static';
      if (this.galleryEl !== null) {
        this.galleryFrameEl = this.galleryEl.querySelector('[data-bundle-gallery-frame]');
        this.galleryMainEl = this.galleryEl.querySelector('[data-bundle-gallery-main]');
        if (this.galleryMainEl === null) {
          warn('Galerie ohne Hauptbild — Bildwechsel bleibt aus.');
        } else {
          this.galleryFallbackSrc = this.galleryMainEl.getAttribute('src');
        }
        /* Theme-Platzhalter (placeholder_svg_tag) steht nur im Markup, wenn es
           weder Startbild noch Produktbild gibt. Optional. */
        this.galleryFallbackEl = this.galleryEl.querySelector('[data-bundle-gallery-fallback]');
        /* Overlay fuer den Crossfade. Fehlt es, wechselt das Bild hart. */
        this.galleryGhostEl = this.galleryEl.querySelector('[data-bundle-gallery-ghost]');
      }

      if (this.totalEl === null || this.atcEl === null) {
        warn('Preis- oder CTA-Knoten fehlt — Konfigurator bleibt im Server-Zustand.');
        return;
      }

      this.addEventListener('change', this.onChangeBound);
      this.addEventListener('click', this.onClickBound);
      /* scroll bubbelt nicht — deshalb in der Capture-Phase mithoeren. */
      this.addEventListener('scroll', this.onScrollBound, true);
      this.addEventListener('moonou:bundle-change', this.onBundleChangeBound);
      /* Capture, damit das Flag steht, bevor der Klick das change-Event ausloest. */
      this.addEventListener('pointerdown', this.onPointerDownBound, true);
      this.addEventListener('keydown', this.onKeydownBound);
      this.addEventListener('focusout', this.onFocusOutBound);
      window.addEventListener('resize', this.onResizeBound);

      this.discountNoticeText = '';
      this.discountRetry = '';
      this.render();

      /* Slots, die schon vom Server fertig gewaehlt kommen (Setting
         "Standardauswahl vorauswaehlen"), haben ihren Erstdurchlauf bereits
         hinter sich — sonst wuerde die erste Aenderung daran den Slot
         zuklappen, obwohl der Kunde ihn gerade absichtlich geoeffnet hat. */
      this.markReadySlotsDone();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChangeBound);
      this.removeEventListener('click', this.onClickBound);
      this.removeEventListener('scroll', this.onScrollBound, true);
      this.removeEventListener('moonou:bundle-change', this.onBundleChangeBound);
      this.removeEventListener('pointerdown', this.onPointerDownBound, true);
      this.removeEventListener('keydown', this.onKeydownBound);
      this.removeEventListener('focusout', this.onFocusOutBound);
      window.removeEventListener('resize', this.onResizeBound);
      if (this.galleryTimer !== 0) {
        window.clearTimeout(this.galleryTimer);
        this.galleryTimer = 0;
      }
      if (this.scrollFrame !== 0) {
        window.cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = 0;
      }
    }

    /* ---------------------------------------------------------------- */
    /* Konfiguration                                                     */
    /* ---------------------------------------------------------------- */

    readConfig() {
      var script = this.querySelector('script[type="application/json"][data-bundle-config]');
      if (script === null) {
        warn('Konfigurations-JSON fehlt — Konfigurator inaktiv.');
        return null;
      }
      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        warn('Konfigurations-JSON ist ungueltig — Konfigurator inaktiv.', error);
        return null;
      }
    }

    /* ---------------------------------------------------------------- */
    /* Zustand aus dem DOM lesen (DOM = Wahrheit)                        */
    /* ---------------------------------------------------------------- */

    slotElement(index) {
      return this.querySelector('[data-bundle-slot][data-slot-index="' + index + '"]');
    }

    readState() {
      var self = this;
      var bulbOn = false;
      if (this.config.bulb.enabled && this.bulbEl !== null) {
        bulbOn = this.bulbEl.checked === true;
      }

      var slots = this.config.slots.map(function (slotCfg) {
        var checked = self.querySelector('[data-bundle-slot-input][data-slot-index="' + slotCfg.index + '"]:checked');
        var handle = checked === null ? null : checked.getAttribute('data-product-handle');
        var color = null;
        if (slotCfg.show_color) {
          var colorInput = self.querySelector('[data-bundle-color-input][data-slot-index="' + slotCfg.index + '"]:checked');
          if (colorInput !== null) color = colorInput.value;
        }
        return { index: slotCfg.index, handle: handle, color: color };
      });

      return { slots: slots, bulbOn: bulbOn };
    }

    /* ---------------------------------------------------------------- */
    /* Rechnung                                                          */
    /* ---------------------------------------------------------------- */

    /**
     * Loest einen Slot in konkrete Warenkorb-Zeilen + Preis auf.
     * mode "product":        1 Zeile (die gewaehlte Variante)
     * mode "lampshade_combo": 2 Zeilen (Sockel + Schirm) wie in der
     *                        Lampenschirm-Buybox
     *
     * `quiet` unterdrueckt die Konsolen-Hinweise. Die Anzeige-Rechnung
     * (computeDisplay) loest dieselben Slots ein zweites Mal auf — ohne den
     * Schalter stuende jede Meldung doppelt in der Konsole.
     */
    resolveSlot(slotCfg, slotState, bulbOn, quiet) {
      var speak = quiet !== true;
      var result = {
        index: slotCfg.index,
        mode: slotCfg.mode,
        ready: false,
        product: null,
        variant: null,
        lines: [],
        price: 0,
        title: '',
        eligibleForCheapest: false,
        soldOut: false
      };

      if (slotState.handle === null) return result;

      var product = findProductByHandle(slotCfg.products, slotState.handle);
      if (product === null) {
        if (speak) warn('Slot ' + slotCfg.index + ': Produkt "' + slotState.handle + '" nicht in der Konfiguration.');
        return result;
      }
      result.product = product;
      result.title = product.title;

      if (product.available !== true) {
        if (speak) warn('Slot ' + slotCfg.index + ': "' + product.handle + '" ist ausverkauft.');
        result.soldOut = true;
        return result;
      }
      /* Farbwahl aktiv, aber nichts gewaehlt -> Slot ist nicht fertig. */
      if (slotCfg.show_color && (slotState.color === null || slotState.color === '')) {
        return result;
      }

      var bulbValue = null;
      if (this.config.bulb.enabled && product.bulb_option_position > 0) {
        bulbValue = bulbOn ? product.bulb_on_value : product.bulb_off_value;
        if (bulbValue === '') bulbValue = null;
      }

      var variant = resolveVariant(product, slotState.color, bulbValue);
      if (variant === null) return result;

      result.variant = variant;
      if (slotState.color !== null && slotState.color !== '') {
        result.title = product.title + ' · ' + slotState.color;
      }

      /* VARIANTENEBENE: das Produkt kann lieferbar sein und die konkrete
         Farb-/Leuchten-Variante trotzdem ausverkauft. Wuerde sie in den
         items-Array wandern, antwortet /cart/add.js mit 422 "Cannot find
         variant" und das GESAMTE Bundle landet nicht im Warenkorb. */
      if (!variantAvailable(variant)) {
        if (speak) warn('Slot ' + slotCfg.index + ': Variante ' + variant.id + ' ("' + result.title + '") ist ausverkauft — Slot nicht bestellbar.');
        result.soldOut = true;
        return result;
      }

      result.ready = true;

      if (slotCfg.mode === 'lampshade_combo') {
        var base = this.config.base;
        if (base === null) {
          if (speak) warn('Slot ' + slotCfg.index + ': Modus "lampshade_combo" ohne Sockel-Produkt (settings.moonou_base_product).');
          result.ready = false;
          return result;
        }
        if (base.available !== true) {
          if (speak) warn('Slot ' + slotCfg.index + ': Sockel "' + base.title + '" ist ausverkauft — Slot nicht bestellbar.');
          result.ready = false;
          result.soldOut = true;
          return result;
        }
        result.lines.push({ variant_id: base.variant_id, quantity: 1, title: base.title, price: base.price, role: 'component' });
        result.lines.push({ variant_id: variant.id, quantity: 1, title: result.title, price: variant.price, role: 'component' });
        result.price = base.price + variant.price;
        result.title = result.title + ' + ' + base.title;
      } else {
        result.lines.push({ variant_id: variant.id, quantity: 1, title: result.title, price: variant.price, role: 'component' });
        result.price = variant.price;
        result.eligibleForCheapest = true;
      }

      return result;
    }

    /** Automatisch beigelegter Artikel — zaehlt nur in den Streichpreis.
     *  `quiet` wie bei resolveSlot: stumm fuer die Anzeige-Rechnung. */
    resolveAuto(autoCfg, resolvedSlots, quiet) {
      var speak = quiet !== true;
      var result = {
        index: autoCfg.index,
        available: false,
        title: '',
        price: 0,
        quantity: autoCfg.quantity,
        badge: autoCfg.badge,
        variant_id: null,
        /* Nur fuer die GRATIS-Box: Thumbnail und roher Produktname. Der
           Warenkorb liest weiterhin `title`. */
        image: '',
        productTitle: ''
      };

      var product = null;
      var variant = null;

      if (autoCfg.mode === 'fixed') {
        product = autoCfg.product;
        if (product === null) {
          if (speak) warn('Automatischer Artikel ' + autoCfg.index + ': kein Produkt hinterlegt.');
          return result;
        }
        variant = findVariantById(product, product.default_variant_id);
      } else {
        var slot = null;
        for (var i = 0; i < resolvedSlots.length; i++) {
          if (resolvedSlots[i].index === autoCfg.match_slot_index) slot = resolvedSlots[i];
        }
        if (slot === null || slot.ready !== true || slot.product === null) {
          /* Slot noch ohne Auswahl: der Gratis-Artikel steht noch nicht fest. */
          return result;
        }
        product = slot.product;
        variant = resolveVariantByOptionValue(product, autoCfg.match_variant_option);
      }

      if (variant === null) {
        if (speak) warn('Automatischer Artikel ' + autoCfg.index + ': keine Variante gefunden.');
        return result;
      }
      if (variant.available !== true) {
        if (speak) warn('Automatischer Artikel ' + autoCfg.index + ' ("' + product.handle + '") ist ausverkauft und entfaellt.');
        return result;
      }

      result.available = true;
      result.variant_id = variant.id;
      result.price = variant.price * autoCfg.quantity;
      result.title = product.title;
      result.productTitle = product.title;
      /* v3.2 — Bild der konkreten Variante zuerst: der weisse Wechselschirm
         soll weiss aussehen, nicht rosa wie das Produktbild. Liquid liefert
         `variant.image` bereits mit Metafeld- und Produktbild-Fallback; ist
         auch das leer, greift hier das Produktbild als letzte Stufe. */
      result.image = typeof variant.image === 'string' && variant.image !== ''
        ? variant.image
        : (typeof product.image === 'string' ? product.image : '');
      if (autoCfg.mode === 'match_slot' && autoCfg.match_variant_option !== '') {
        result.title = product.title + ' · ' + autoCfg.match_variant_option;
      }
      return result;
    }

    /** Kompletter Rechenstand: Slots, Autos, Leuchtmittel, Gratis-Regel. */
    compute() {
      var self = this;
      var state = this.readState();
      var notices = [];

      var slots = this.config.slots.map(function (slotCfg, i) {
        return self.resolveSlot(slotCfg, state.slots[i], state.bulbOn);
      });

      var autos = this.config.auto_items.map(function (autoCfg) {
        return self.resolveAuto(autoCfg, slots);
      });

      /* Leuchtmittel: bei "product"-Slots steckt die Leuchte in der Variante.
         Bei "lampshade_combo" gibt es keine Leuchten-Option -> je Slot eine
         E27-Zeile als echter Zusatzartikel. */
      var bulbCount = 0;
      if (state.bulbOn && this.config.bulb.enabled && this.config.bulb.extra !== null) {
        if (this.config.bulb.extra.available !== true) {
          warn('Leuchtmittel "' + this.config.bulb.extra.title + '" ist ausverkauft — keine E27-Zeile.');
          notices.push('Das Leuchtmittel ist derzeit nicht verfügbar und entfällt.');
        } else {
          for (var s = 0; s < slots.length; s++) {
            if (slots[s].mode === 'lampshade_combo' && slots[s].ready) bulbCount++;
          }
        }
      }
      var bulbTotal = bulbCount * (this.config.bulb.extra === null ? 0 : this.config.bulb.extra.price);

      var sumSlots = 0;
      var ready = slots.length > 0;
      for (var i = 0; i < slots.length; i++) {
        if (slots[i].ready) {
          sumSlots += slots[i].price;
        } else {
          ready = false;
          /* Ausverkaufte Auswahl BEIM NAMEN nennen — sonst steht der Kunde
             vor einem gesperrten Button ohne Grund (oder, schlimmer, vor
             einem gescheiterten ATC ohne Hinweis, welche Wahl schuld ist). */
          if (slots[i].soldOut) {
            var soldTitle = slots[i].title === '' ? this.config.slots[i].heading : slots[i].title;
            notices.push('„' + soldTitle + '" ist derzeit ausverkauft. Bitte wähle bei „' + this.config.slots[i].heading + '" etwas anderes.');
          }
        }
      }

      var sumAutos = 0;
      for (var a = 0; a < autos.length; a++) {
        if (autos[a].available) {
          sumAutos += autos[a].price;
        } else if (ready && notices.indexOf(NOTICE_AUTO_MISSING) === -1) {
          notices.push(NOTICE_AUTO_MISSING);
        }
      }

      var cheapest = this.cheapestSlot(slots, ready);
      var gratisSlotIndex = cheapest.index;
      var gratisAmount = cheapest.amount;

      var compareTotal = sumSlots + bulbTotal + sumAutos;
      var total = sumSlots + bulbTotal - gratisAmount;
      var savings = compareTotal - total;
      if (savings < 0) savings = 0;

      /* Anzeige-Trio fuer den Preisblock. Ist das Bundle fertig, zeigt es die
         echte Rechnung; sonst die gemischte (siehe computeDisplay). */
      var display = ready
        ? { total: total, compare: compareTotal, savings: savings }
        : this.computeDisplay(state, slots);

      return {
        state: state,
        slots: slots,
        autos: autos,
        bulbCount: bulbCount,
        bulbTotal: bulbTotal,
        ready: ready,
        total: total,
        compareTotal: compareTotal,
        savings: savings,
        display: display,
        gratisSlotIndex: gratisSlotIndex,
        notices: notices
      };
    }

    /**
     * Gratis-Regel "cheapest_slot": der guenstigste "product"-Slot wird 0 EUR.
     * Shopify entscheidet das per BXGY genauso (guenstigster Artikel).
     *
     * v3.1 — Bei PREISGLEICHHEIT gewinnt der LETZTE in Frage kommende Slot
     * ("<=" statt "<"). Genau das ist der Normalfall des Wohnzimmer-Bundles:
     * zwei gleich teure Tischlampen. Vorher fiel das Gratis auf "Tischlampe 1",
     * waehrend das feste Kopf-Badge an "Tischlampe 2" hing — Fahne, Kopf-Badge
     * und `_bundle_role: gratis` im Warenkorb zeigten auf verschiedene Zeilen.
     */
    cheapestSlot(slots, enabled) {
      var result = { index: null, amount: 0 };
      if (this.config.gratis_rule !== 'cheapest_slot' || enabled !== true) return result;
      for (var c = 0; c < slots.length; c++) {
        if (!slots[c].eligibleForCheapest || !slots[c].ready) continue;
        if (result.index === null || slots[c].price <= result.amount) {
          result.index = slots[c].index;
          result.amount = slots[c].price;
        }
      }
      if (result.index === null) result.amount = 0;
      return result;
    }

    /**
     * Anzeige-Rechnung fuer die Teilauswahl: jeder noch nicht fertige Slot
     * wird durch seine Referenz-Kombination ersetzt (Standardprodukt +
     * Standardfarbe aus dem Liquid), fertige Slots zaehlen mit der echten
     * Wahl. Damit bewegt sich der Preisblock ab dem ersten Klick, der
     * Leuchten-Toggle wirkt auf BEIDE Anteile — und es steht nie der Preis
     * einer einzelnen Lampe als Bundle-Preis da.
     * Ohne jede Auswahl ergibt das exakt die serverseitigen Startzahlen.
     */
    computeDisplay(state, resolvedSlots) {
      var self = this;
      var refs = Array.isArray(this.config.slot_reference) ? this.config.slot_reference : [];

      var mixed = this.config.slots.map(function (slotCfg, i) {
        if (resolvedSlots[i].ready === true) return resolvedSlots[i];
        var ref = null;
        for (var r = 0; r < refs.length; r++) {
          if (refs[r].index === slotCfg.index) ref = refs[r];
        }
        if (ref === null) return resolvedSlots[i];
        var color = typeof ref.color === 'string' && ref.color !== '' ? ref.color : null;
        return self.resolveSlot(
          slotCfg,
          { index: slotCfg.index, handle: ref.handle, color: color },
          state.bulbOn,
          true
        );
      });

      var sumSlots = 0;
      var allReady = mixed.length > 0;
      for (var i = 0; i < mixed.length; i++) {
        if (mixed[i].ready) {
          sumSlots += mixed[i].price;
        } else {
          allReady = false;
        }
      }

      var sumAutos = 0;
      for (var a = 0; a < this.config.auto_items.length; a++) {
        var auto = this.resolveAuto(this.config.auto_items[a], mixed, true);
        if (auto.available) sumAutos += auto.price;
      }

      var bulbTotal = 0;
      var extra = this.config.bulb.extra;
      if (state.bulbOn && this.config.bulb.enabled && extra !== null && extra.available === true) {
        var bulbCount = 0;
        for (var b = 0; b < mixed.length; b++) {
          if (mixed[b].mode === 'lampshade_combo' && mixed[b].ready) bulbCount++;
        }
        bulbTotal = bulbCount * extra.price;
      }

      var cheapest = this.cheapestSlot(mixed, allReady);
      var compare = sumSlots + bulbTotal + sumAutos;
      var total = sumSlots + bulbTotal - cheapest.amount;
      var savings = compare - total;
      if (savings < 0) savings = 0;

      return { total: total, compare: compare, savings: savings };
    }

    /* ---------------------------------------------------------------- */
    /* Rendering                                                         */
    /* ---------------------------------------------------------------- */

    onChange(event) {
      var target = event.target;
      if (target === null || typeof target.matches !== 'function') return;

      var touchedSlot = NaN;
      if (target.matches('[data-bundle-slot-input]')) {
        touchedSlot = parseInt(target.getAttribute('data-slot-index'), 10);
        this.syncColorRows(touchedSlot);
      } else if (target.matches('[data-bundle-color-input]')) {
        touchedSlot = parseInt(target.getAttribute('data-slot-index'), 10);
      }

      if (target.matches('[data-bundle-slot-input], [data-bundle-color-input], [data-bundle-bulb]')) {
        var byPointer = this.pointerSelect;
        this.pointerSelect = false;

        /* Die Galerie folgt der juengsten Entscheidung des Kunden. */
        if (!isNaN(touchedSlot)) this.galleryIndex = touchedSlot;
        this.render();

        /* Nur eine Pointer-Auswahl klappt den Slot sofort zu. Pfeiltasten in
           der Radiogroup loesen ebenfalls change aus — wuerde der Slot dabei
           zuklappen, verschwaende das gerade fokussierte Radio und der Fokus
           faende sich auf <body> wieder. Per Tastatur bleibt der Slot offen,
           bis Enter bestaetigt oder der Fokus ihn verlaesst.
           applyAccordion() haelt sich bei einem Slot, der seinen
           Erstdurchlauf hinter sich hat, von selbst heraus (v3.2). */
        if (!isNaN(touchedSlot) && byPointer) this.applyAccordion(touchedSlot, true);
      }
    }

    /** Merkt vor, dass die naechste Auswahl per Maus oder Finger kommt. Dem
     *  change-Event selbst sieht man die Eingabeart nicht an.
     *
     *  Klickt der Kunde die bereits gewaehlte Karte an, kommt gar kein
     *  change-Event und das Flag bliebe stehen. Deshalb raeumt jeder
     *  pointerdown NEBEN einer Karte es wieder ab; die Tastaturbedienung
     *  setzt es zusaetzlich in onKeydown zurueck. Ein Timer waere hier falsch:
     *  zwischen pointerdown und dem change des Labels liegt die gesamte
     *  Klickdauer (real 50-150 ms), ein setTimeout(0) kaeme viel zu frueh. */
    onPointerDown(event) {
      var target = event.target;
      if (target === null || typeof target.closest !== 'function') return;
      var hit = target.closest(
        '[data-bundle-slot-input], [data-bundle-color-input], [data-bundle-card], .moonou-swatch'
      );
      this.pointerSelect = hit !== null;
    }

    /**
     * Tastaturbedienung der Karten-Radiogroup.
     * Pfeiltasten waehlen sofort aus (Browser-Standard) — der Slot bleibt
     * dabei bewusst offen. Enter bestaetigt und klappt weiter.
     */
    onKeydown(event) {
      var target = event.target;
      if (target === null || typeof target.matches !== 'function') return;
      if (!target.matches('[data-bundle-slot-input], [data-bundle-color-input]')) return;

      this.pointerSelect = false;
      if (event.key !== 'Enter') return;

      var index = parseInt(target.getAttribute('data-slot-index'), 10);
      if (isNaN(index)) {
        warn('Tastatur-Auswahl ohne Slot-Index — Slot bleibt offen.');
        return;
      }
      event.preventDefault();
      this.applyAccordion(index, true);
    }

    /**
     * Verlaesst der Fokus einen offenen Slot, der seinen Erstdurchlauf noch
     * VOR sich hat und gerade fertig geworden ist, klappt er zu. Der Fokus
     * wird dabei NICHT zurueckgeholt — er ist ja absichtlich weiter.
     *
     * v3.2 — Wichtig: Dieses focusout feuert schon beim mousedown auf die
     * naechste Karte (der Accordion-Kopf verliert den Fokus, relatedTarget ist
     * null, weil ein <label> nicht fokussierbar ist) — also VOR mouseup und
     * change. Solange hier ein bereits gewaehlter Slot zugeklappt wurde, fiel
     * das Label unter dem Zeiger weg, mouseup landete auf dem Slot-Koerper und
     * es gab nie ein change-Event: das war der Bug "Aendern -> andere Karte
     * klicken -> Accordion klappt nur zu, Auswahl bleibt alt". Die
     * Erstdurchlauf-Sperre in applyAccordion() beendet das.
     */
    onFocusOut(event) {
      var target = event.target;
      if (target === null || typeof target.closest !== 'function') return;
      var slot = target.closest('[data-bundle-slot]');
      if (slot === null || !slot.hasAttribute('data-slot-open')) return;

      var next = event.relatedTarget;
      if (next !== null && typeof slot.contains === 'function' && slot.contains(next)) return;

      var index = parseInt(slot.getAttribute('data-slot-index'), 10);
      if (isNaN(index)) {
        warn('Slot ohne Index — Zuklappen beim Fokuswechsel entfaellt.');
        return;
      }
      this.applyAccordion(index, false);
    }

    /** Systemeinstellung "Bewegung reduzieren". */
    reducedMotion() {
      if (typeof window.matchMedia !== 'function') return false;
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    /** scroll bubbelt nicht — der Capture-Listener faengt jeden Track ab.
     *  Die Neuvermessung laeuft hoechstens einmal pro Frame: waehrend eines
     *  Wischers feuert scroll sonst dutzendfach, und jedes setAttribute auf
     *  dem Slider zieht ein Style-Recalc mitten in die Momentum-Bewegung. */
    onScroll(event) {
      var target = event.target;
      if (target === null || typeof target.closest !== 'function') return;
      var slider = target.closest('[data-bundle-slider]');
      if (slider === null) return;

      if (typeof window.requestAnimationFrame !== 'function') {
        this.updateSlider(slider);
        return;
      }
      if (this.scrollFrame !== 0) return;
      var self = this;
      this.scrollFrame = window.requestAnimationFrame(function () {
        self.scrollFrame = 0;
        self.updateSlider(slider);
      });
    }

    onResize() {
      this.updateSliders();
    }

    /** Galerie haengt am eigenen Change-Event — der Datenstand liegt in
     *  this.lastData (bewusst VOR dem dispatch gesetzt). */
    onBundleChange() {
      if (this.galleryEl === null || this.galleryMainEl === null) return;
      if (this.lastData === null) return;
      this.renderGallery(this.lastData);
    }

    onClick(event) {
      var target = event.target;
      if (target === null || typeof target.closest !== 'function') return;

      var toggle = target.closest('[data-bundle-slot-toggle]');
      if (toggle !== null) {
        event.preventDefault();
        var toggleSlot = toggle.closest('[data-bundle-slot]');
        if (toggleSlot === null) {
          warn('Accordion-Kopf ohne Slot-Element.');
          return;
        }
        var index = parseInt(toggleSlot.getAttribute('data-slot-index'), 10);
        var willOpen = !toggleSlot.hasAttribute('data-slot-open');
        /* Wer einen fertigen Slot von Hand zuklappt, hat dessen Erstdurchlauf
           abgeschlossen — danach entscheidet nur noch der Kopf ueber auf/zu. */
        if (!willOpen && this.slotIsReady(index)) this.markSlotDone(index);
        this.setSlotOpen(index, willOpen);
        return;
      }

      var arrow = target.closest('[data-bundle-arrow]');
      if (arrow !== null) {
        event.preventDefault();
        this.scrollSlider(arrow);
        return;
      }

      var thumb = target.closest('[data-bundle-gallery-thumb]');
      if (thumb !== null) {
        event.preventDefault();
        if (thumb.hasAttribute('data-placeholder')) return;

        /* Statische Galerie: das Thumbnail traegt sein Bild selbst, es gibt
           keinen Slot dahinter. Nur Bild tauschen und Markierung umsetzen. */
        var staticImage = thumb.getAttribute('data-image');
        if (this.galleryStatic && staticImage !== null && staticImage !== '') {
          var all = this.galleryEl.querySelectorAll('[data-bundle-gallery-thumb]');
          for (var g = 0; g < all.length; g++) all[g].removeAttribute('data-active');
          thumb.setAttribute('data-active', '');
          this.setGalleryRatio(thumb.getAttribute('data-ratio'));
          this.setGalleryImage(staticImage, null);
          return;
        }

        var thumbIndex = parseInt(thumb.getAttribute('data-slot-index'), 10);
        if (isNaN(thumbIndex)) {
          warn('Galerie-Thumbnail ohne Slot-Index.');
          return;
        }
        this.galleryIndex = thumbIndex;
        if (this.lastData !== null) this.renderGallery(this.lastData);
        return;
      }

      var retry = target.closest('[data-bundle-discount-retry]');
      if (retry !== null) {
        event.preventDefault();
        /* Zwei verschiedene Fehler, zwei verschiedene Wiederholungen:
           scheiterte schon der ATC, hilft ein Rabatt-Retry nicht. */
        if (this.discountRetry === 'atc') {
          this.addToCart();
        } else {
          this.applyDiscount(true);
        }
        return;
      }

      var atc = target.closest('[data-bundle-atc]');
      if (atc !== null) {
        event.preventDefault();
        this.addToCart();
      }
    }

    /**
     * Farbreihen umschalten: sichtbar ist genau die Reihe des gewaehlten
     * Produkts. Alle Reihen eines Slots teilen einen Radio-Namen — der
     * gecheckte Radio kann also in einer versteckten Reihe liegen. Deshalb
     * wird die Farbe in die sichtbare Reihe uebernommen (gleicher Wert,
     * sonst erster verfuegbarer Wert).
     */
    syncColorRows(slotIndex) {
      if (isNaN(slotIndex)) return;
      var slotCfg = null;
      for (var i = 0; i < this.config.slots.length; i++) {
        if (this.config.slots[i].index === slotIndex) slotCfg = this.config.slots[i];
      }
      if (slotCfg === null || slotCfg.show_color !== true) return;

      var checked = this.querySelector('[data-bundle-slot-input][data-slot-index="' + slotIndex + '"]:checked');
      if (checked === null) return;
      var handle = checked.getAttribute('data-product-handle');

      var previous = null;
      var previousInput = this.querySelector('[data-bundle-color-input][data-slot-index="' + slotIndex + '"]:checked');
      if (previousInput !== null) previous = previousInput.value;

      var rows = this.querySelectorAll('[data-bundle-colors][data-slot-index="' + slotIndex + '"]');
      var activeRow = null;
      for (var r = 0; r < rows.length; r++) {
        var isActive = rows[r].getAttribute('data-product-handle') === handle;
        rows[r].hidden = !isActive;
        if (isActive) activeRow = rows[r];
      }
      if (activeRow === null) {
        warn('Slot ' + slotIndex + ': keine Farbreihe fuer "' + handle + '".');
        return;
      }

      var inputs = activeRow.querySelectorAll('[data-bundle-color-input]');
      if (inputs.length === 0) return;

      var wanted = null;
      var firstFree = null;
      for (var k = 0; k < inputs.length; k++) {
        /* Ausverkaufte Farben werden nicht uebernommen — sonst landet der
           Kunde nach dem Produktwechsel in einer nicht bestellbaren
           Kombination, obwohl das Produkt in anderer Farbe lieferbar ist. */
        var free = inputs[k].hasAttribute('data-unavailable') === false && inputs[k].disabled !== true;
        if (free && firstFree === null) firstFree = inputs[k];
        if (previous !== null && inputs[k].value === previous && free) wanted = inputs[k];
      }
      /* Ohne Vorauswahl (preselect_defaults aus) und ohne vorherige Farbe
         bleibt die Reihe absichtlich unbeantwortet — der Kunde waehlt. */
      if (wanted === null && previous !== null) wanted = firstFree;
      if (wanted !== null) wanted.checked = true;
    }

    /**
     * Farb-Swatches der sichtbaren Reihen auf Variantenebene sperren.
     * Der Serverzustand (A1) kennt den Leuchten-Toggle noch nicht — nach
     * dem Umschalten kann eine bis dahin lieferbare Farbe ausverkauft sein.
     */
    renderColorAvailability(data) {
      var config = this.config;
      for (var i = 0; i < config.slots.length; i++) {
        var slotCfg = config.slots[i];
        if (slotCfg.show_color !== true) continue;

        var inputs = this.querySelectorAll('[data-bundle-color-input][data-slot-index="' + slotCfg.index + '"]');
        for (var k = 0; k < inputs.length; k++) {
          var input = inputs[k];
          var product = findProductByHandle(slotCfg.products, input.getAttribute('data-product-handle'));
          if (product === null) continue;

          var bulbValue = null;
          if (config.bulb.enabled && product.bulb_option_position > 0) {
            bulbValue = data.state.bulbOn ? product.bulb_on_value : product.bulb_off_value;
            if (bulbValue === '') bulbValue = null;
          }
          var variant = resolveVariant(product, input.value, bulbValue);
          var free = variant !== null && variantAvailable(variant);

          if (free) {
            input.removeAttribute('data-unavailable');
            input.disabled = false;
          } else {
            input.setAttribute('data-unavailable', '');
            /* Eine bereits gewaehlte Farbe wird NICHT hart disabled — ein
               disabled Radio laesst sich nicht mehr abwaehlen und der Kunde
               saesse fest. Die Sperre uebernimmt der Slot (nicht bestellbar
               + Hinweis), sichtbar ausgegraut ist die Farbe trotzdem. */
            input.disabled = input.checked !== true;
          }
        }
      }
    }

    render() {
      var data = this.compute();

      this.renderCards(data);
      this.renderColorAvailability(data);
      this.renderColorLabels(data);
      this.renderGratisBox(data);
      this.renderTotals(data);
      this.renderCta(data);
      this.renderProgress(data);
      this.renderSlotHeads(data);

      /* VOR dem Event setzen: die Galerie haengt am Event und liest hier. */
      this.lastData = data;

      this.dispatchEvent(new CustomEvent('moonou:bundle-change', {
        bubbles: true,
        detail: {
          ready: data.ready,
          total: data.total,
          compareTotal: data.compareTotal,
          items: this.buildItems(data, null)
        }
      }));

      this.updateSliders();
    }

    /* ---------------------------------------------------------------- */
    /* v2: Fortschritt, Accordion, Slider, Galerie                       */
    /* ---------------------------------------------------------------- */

    /** "X von Y gewählt" plus Fortschrittsbalken. */
    renderProgress(data) {
      var total = data.slots.length;
      var done = 0;
      for (var i = 0; i < data.slots.length; i++) {
        if (data.slots[i].ready) done++;
      }
      if (this.progressDoneEl !== null) this.progressDoneEl.textContent = String(done);
      if (this.progressTotalEl !== null) this.progressTotalEl.textContent = String(total);
      if (this.progressFillEl !== null) {
        /* Faktor 0..1, nicht Prozent: der Balken faehrt per scaleX aus (wie
           das Theme-Element progress-bar), nicht ueber die Breite. */
        var factor = total === 0 ? 0 : done / total;
        this.progressFillEl.style.setProperty('--m-bundle-progress', String(factor));
      }
      /* Glanz-Sweep nur waehrend der Konfiguration: bei 0 % ist die Schiene
         leer, bei 100 % ist der Schritt erledigt und das Glanzlicht zoege die
         Aufmerksamkeit vom CTA weg. */
      if (this.progressEl !== null) {
        var running = done > 0 && done < total;
        if (running) {
          this.progressEl.setAttribute('data-progress-running', '');
        } else {
          this.progressEl.removeAttribute('data-progress-running');
        }
      }
    }

    /**
     * Kompakte Auswahlzeile im Accordion-Kopf (Mini-Thumb + Name + GRATIS).
     * Rein anzeigend — den Auf-/Zuklapp-Zustand steuert applyAccordion().
     */
    renderSlotHeads(data) {
      for (var i = 0; i < data.slots.length; i++) {
        var resolved = data.slots[i];
        var slotCfg = this.config.slots[i];
        var slotState = data.state.slots[i];
        var element = this.slotElement(resolved.index);
        if (element === null) {
          warn('Slot ' + resolved.index + ': kein Element im DOM.');
          continue;
        }

        if (resolved.ready) {
          element.setAttribute('data-slot-done', '');
        } else {
          element.removeAttribute('data-slot-done');
        }

        var chosen = element.querySelector('[data-bundle-slot-chosen]');
        if (chosen === null) continue;

        if (resolved.product === null) {
          chosen.hidden = true;
          chosen.removeAttribute('data-visible');
          continue;
        }
        if (chosen.hidden) {
          /* Aus [hidden] heraus gibt es keinen Startzustand fuer eine
             Transition. Deshalb erst einblenden, dann im naechsten Frame
             sichtbar schalten. */
          chosen.hidden = false;
          this.revealSoon(chosen);
        } else {
          chosen.setAttribute('data-visible', '');
        }

        var thumb = chosen.querySelector('[data-bundle-slot-thumb]');
        var thumbFallback = chosen.querySelector('[data-bundle-slot-thumb-fallback]');
        if (thumb !== null) {
          /* v3.3 — Der Kopf-Thumb zeigt die KONKRETE Auswahl: liegt ein Bild
             der gewaehlten Variante vor (Farbe), gewinnt es vor dem
             Produktbild. */
          var headImage = resolved.variant !== null &&
            typeof resolved.variant.image === 'string' && resolved.variant.image !== ''
            ? resolved.variant.image
            : resolved.product.image;
          if (typeof headImage === 'string' && headImage !== '') {
            thumb.setAttribute('src', headImage);
            thumb.setAttribute('alt', resolved.product.title);
            thumb.hidden = false;
            if (thumbFallback !== null) thumbFallback.hidden = true;
          } else {
            /* Produkt ohne Bild: Theme-Platzhalter statt leeres Bild. */
            thumb.removeAttribute('src');
            thumb.hidden = true;
            if (thumbFallback !== null) thumbFallback.hidden = false;
          }
        }

        /* Anzeigename: Produktname ohne das ausgeblendete Wort, danach das
           Muster des Slots ("Cora Lampe Rosa"). resolved.title bleibt
           unangetastet — daran haengen die Warenkorb-Properties. */
        var name = chosen.querySelector('[data-bundle-slot-name]');
        if (name !== null) {
          var displayName = stripWord(resolved.product.title, slotCfg.title_remove);
          name.textContent = formatChosen(slotCfg.chosen_pattern, displayName, slotState.color);
        }

        var gratis = chosen.querySelector('[data-bundle-slot-gratis]');
        if (gratis !== null) gratis.hidden = data.gratisSlotIndex !== resolved.index;
      }

      this.renderHeaderBadges(data);
    }

    /**
     * Das feste Kopf-Badge (Setting `header_badge`, z. B. "GRATIS" an
     * "Tischlampe 2") darf nicht stehen bleiben, wenn die Gratis-Regel einen
     * anderen Slot bestimmt — etwa weil in Slot 1 eine guenstigere Lampe
     * liegt. Konsistenz vor Statik: Kopf-Badge, Karten-Fahne und
     * `_bundle_role: gratis` im Warenkorb zeigen dann denselben Slot.
     * Solange noch kein Gratis-Slot feststeht (unvollstaendiges Bundle),
     * bleibt das Badge als Werbeaussage stehen.
     */
    renderHeaderBadges(data) {
      var badges = this.querySelectorAll('[data-bundle-slot-header-badge]');
      for (var i = 0; i < badges.length; i++) {
        var slot = badges[i].closest('[data-bundle-slot]');
        if (slot === null) {
          warn('Kopf-Badge ohne Slot-Element — bleibt sichtbar.');
          continue;
        }
        var index = parseInt(slot.getAttribute('data-slot-index'), 10);
        if (isNaN(index)) {
          warn('Kopf-Badge in einem Slot ohne Index — bleibt sichtbar.');
          continue;
        }
        badges[i].hidden = data.gratisSlotIndex !== null && data.gratisSlotIndex !== index;
      }
    }

    /** Einen Slot auf-/zuklappen (inkl. aria und Slider-Neuvermessung). */
    setSlotOpen(index, open) {
      var element = this.slotElement(index);
      if (element === null) {
        warn('Slot ' + index + ' laesst sich nicht umschalten — kein Element.');
        return;
      }
      if (open) {
        element.setAttribute('data-slot-open', '');
      } else {
        element.removeAttribute('data-slot-open');
      }
      var toggle = element.querySelector('[data-bundle-slot-toggle]');
      if (toggle !== null) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      /* Ein Track in einem zugeklappten Body misst 0 — nach dem Oeffnen
         muessen die Pfeile neu bewertet werden. */
      if (open) {
        var slider = element.querySelector('[data-bundle-slider]');
        if (slider !== null) this.updateSlider(slider);
      }
    }

    /** Ein Element erst im naechsten Frame als sichtbar markieren. */
    revealSoon(element) {
      if (typeof window.requestAnimationFrame !== 'function') {
        element.setAttribute('data-visible', '');
        return;
      }
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          element.setAttribute('data-visible', '');
        });
      });
      window.setTimeout(function () {
        element.setAttribute('data-visible', '');
      }, 120);
    }

    /** Ist der Slot nach dem letzten Rechenstand fertig gewaehlt? */
    slotIsReady(index) {
      if (this.lastData === null) return false;
      var slots = this.lastData.slots;
      for (var i = 0; i < slots.length; i++) {
        if (slots[i].index === index) return slots[i].ready === true;
      }
      return false;
    }

    /** Slot hat seinen Erstdurchlauf hinter sich: ab jetzt kein Auto-Zuklappen. */
    markSlotDone(index) {
      if (isNaN(index)) return;
      this.slotDone[index] = true;
    }

    /** Alle bereits fertigen Slots als "Erstdurchlauf erledigt" markieren. */
    markReadySlotsDone() {
      if (this.lastData === null) return;
      var slots = this.lastData.slots;
      for (var i = 0; i < slots.length; i++) {
        if (slots[i].ready === true) this.markSlotDone(slots[i].index);
      }
    }

    /**
     * Accordion-Fluss im ERSTDURCHLAUF: eine fertige Auswahl klappt ihren Slot
     * zu und der naechste noch offene Slot bleibt/wird geoeffnet. Unfertige
     * Slots (Produkt gewaehlt, Farbe fehlt) bleiben absichtlich offen.
     *
     * v3.2 — Hat ein Slot seinen Erstdurchlauf hinter sich (this.slotDone),
     * passiert hier NICHTS mehr: ein wieder geoeffneter Slot bleibt offen,
     * egal ob der Kunde eine andere Karte waehlt oder den Fokus wegzieht. Nur
     * Kopf/"Aendern" schliesst ihn dann noch. Das behebt zugleich den Bug, bei
     * dem das focusout beim mousedown den Slot zuklappte und der Klick damit
     * ins Leere lief (siehe onFocusOut).
     *
     * `moveFocus`: lag der Fokus im zuklappenden Slot, wandert er auf den
     * Accordion-Kopf des neu geoeffneten Slots (sonst auf den eigenen Kopf).
     * Ohne das faellt der Fokus auf <body>, weil der zugeklappte Koerper
     * visibility:hidden bekommt.
     */
    applyAccordion(changedIndex, moveFocus) {
      if (this.lastData === null) return;
      var slots = this.lastData.slots;

      var changed = null;
      for (var i = 0; i < slots.length; i++) {
        if (slots[i].index === changedIndex) changed = slots[i];
      }
      if (changed === null || changed.ready !== true) return;
      if (this.slotDone[changedIndex] === true) return;
      this.markSlotDone(changedIndex);

      var element = this.slotElement(changedIndex);
      if (element === null) {
        warn('Slot ' + changedIndex + ': kein Element zum Zuklappen.');
        return;
      }
      var focusWasInside = element.contains(document.activeElement);

      this.setSlotOpen(changedIndex, false);

      var openedIndex = null;
      for (var k = 0; k < slots.length; k++) {
        if (slots[k].ready) continue;
        this.setSlotOpen(slots[k].index, true);
        openedIndex = slots[k].index;
        break;
      }

      if (moveFocus !== true || !focusWasInside) return;

      var focusIndex = openedIndex === null ? changedIndex : openedIndex;
      var focusElement = this.slotElement(focusIndex);
      if (focusElement === null) {
        warn('Slot ' + focusIndex + ': kein Element fuer die Fokusuebergabe.');
        return;
      }
      var toggle = focusElement.querySelector('[data-bundle-slot-toggle]');
      if (toggle === null) {
        warn('Slot ' + focusIndex + ': kein Accordion-Kopf fuer die Fokusuebergabe.');
        return;
      }
      toggle.focus();
    }

    updateSliders() {
      var sliders = this.querySelectorAll('[data-bundle-slider]');
      for (var i = 0; i < sliders.length; i++) {
        this.updateSlider(sliders[i]);
      }
    }

    /** Pfeile (Desktop) bzw. Fade-Out (Mobil) an den Scrollstand koppeln. */
    updateSlider(slider) {
      var track = slider.querySelector('[data-bundle-track]');
      if (track === null) {
        warn('Slider ohne Kartenspur — Pfeile bleiben aus.');
        return;
      }
      var max = track.scrollWidth - track.clientWidth;
      var left = track.scrollLeft;

      if (max > 2 && left > 2) {
        slider.setAttribute('data-can-prev', '');
      } else {
        slider.removeAttribute('data-can-prev');
      }
      if (max > 2 && left < max - 2) {
        slider.setAttribute('data-can-next', '');
      } else {
        slider.removeAttribute('data-can-next');
      }
    }

    scrollSlider(arrow) {
      var slider = arrow.closest('[data-bundle-slider]');
      if (slider === null) {
        warn('Pfeil ohne Slider-Element.');
        return;
      }
      var track = slider.querySelector('[data-bundle-track]');
      if (track === null) {
        warn('Pfeil ohne Kartenspur.');
        return;
      }
      var direction = arrow.getAttribute('data-bundle-arrow') === 'prev' ? -1 : 1;
      var step = Math.max(Math.round(track.clientWidth * 0.8), 160);

      if (typeof track.scrollBy === 'function') {
        track.scrollBy({
          left: direction * step,
          behavior: this.reducedMotion() ? 'auto' : 'smooth'
        });
      } else {
        track.scrollLeft = track.scrollLeft + direction * step;
      }
      /* Die Scroll-Events waehrend der Fahrt halten die Pfeile aktuell; der
         Aufruf hier deckt nur den Fall ab, dass gar kein Event kommt. */
      this.updateSlider(slider);
    }

    /**
     * Bildformat der statischen Galerie. Nur im Setting "Wie das Bild"
     * (adapt) folgt der Rahmen dem jeweiligen Bild — genauso, wie
     * snippets/product-media.liquid mit --aspect-ratio arbeitet. Bei den
     * festen Formaten (quadratisch/hochkant) bleibt der Rahmen, wie Liquid
     * ihn gesetzt hat.
     */
    setGalleryRatio(ratio) {
      if (this.galleryFrameEl === null) return;
      if (this.galleryEl === null || !this.galleryEl.hasAttribute('data-gallery-ratio-adapt')) return;
      var value = parseFloat(ratio);
      if (isNaN(value) || value <= 0) {
        warn('Galerie-Thumbnail ohne nutzbares Seitenverhaeltnis — Rahmen bleibt.');
        return;
      }
      this.galleryFrameEl.style.setProperty('--m-bundle-gallery-ratio', String(value));
    }

    /**
     * Hauptbild und Theme-Platzhalter gegeneinander schalten. Ohne
     * Platzhalter im Markup passiert nur das Ein-/Ausblenden des Bildes.
     */
    showGalleryImage(visible) {
      if (this.galleryMainEl !== null) this.galleryMainEl.hidden = !visible;
      if (this.galleryFallbackEl !== null) this.galleryFallbackEl.hidden = visible;
    }

    /**
     * Live-Galerie: Hauptbild + Thumbnails sind die gewaehlten Produkte.
     * Ohne Auswahl bleibt der Server-Erstzustand (Startbild) stehen.
     */
    renderGallery(data) {
      /* Statische Galerie (Default seit v3): kuratierte Bilder, die sich NICHT
         mit der Auswahl aendern. Hier hat der Konfigurator nichts zu suchen. */
      if (this.galleryStatic) return;

      var thumbs = this.galleryEl.querySelectorAll('[data-bundle-gallery-thumb]');

      /* Welcher Slot liegt vorn? Bevorzugt der zuletzt geaenderte, sonst
         der erste fertige mit Bild. */
      var activeIndex = null;
      var activeSlot = null;
      var firstReady = null;
      for (var i = 0; i < data.slots.length; i++) {
        var slot = data.slots[i];
        if (slot.ready !== true || slot.product === null) continue;
        if (typeof slot.product.image_large !== 'string' || slot.product.image_large === '') continue;
        if (firstReady === null) firstReady = slot;
        if (slot.index === this.galleryIndex) activeSlot = slot;
      }
      if (activeSlot === null) activeSlot = firstReady;
      if (activeSlot !== null) activeIndex = activeSlot.index;

      if (activeSlot === null) {
        if (this.galleryFallbackSrc !== '' && this.galleryFallbackSrc !== null) {
          this.setGalleryImage(this.galleryFallbackSrc, null);
          this.showGalleryImage(true);
        } else {
          /* Kein Startbild hinterlegt: Theme-Platzhalter zeigen statt ein
             leeres Bild. */
          this.galleryMainEl.removeAttribute('src');
          this.showGalleryImage(false);
        }
      } else {
        this.setGalleryImage(activeSlot.product.image_large, activeSlot.title);
        this.showGalleryImage(true);
      }

      for (var t = 0; t < thumbs.length; t++) {
        var thumb = thumbs[t];
        var slotIndex = parseInt(thumb.getAttribute('data-slot-index'), 10);
        var match = null;
        for (var s = 0; s < data.slots.length; s++) {
          if (data.slots[s].index === slotIndex) match = data.slots[s];
        }

        var image = null;
        var label = String(isNaN(slotIndex) ? '' : slotIndex);
        if (match !== null && match.product !== null && typeof match.product.image === 'string' && match.product.image !== '') {
          image = match.product.image;
          label = match.title;
        }

        this.paintThumb(thumb, image, label);

        if (image !== null && slotIndex === activeIndex) {
          thumb.setAttribute('data-active', '');
        } else {
          thumb.removeAttribute('data-active');
        }
      }
    }

    /**
     * Hauptbild wechseln, ohne Weissblitz und ohne Layout-Sprung: das Overlay
     * haelt das ALTE Bild, waehrend das Hauptbild das neue laedt; erst wenn
     * das neue dekodiert ist, blendet das Overlay aus.
     */
    setGalleryImage(url, alt) {
      var main = this.galleryMainEl;
      if (main === null) return;
      if (typeof alt === 'string' && alt !== '') main.setAttribute('alt', alt);

      var current = main.getAttribute('src');
      if (current === url) return;

      var ghost = this.galleryGhostEl;
      var canCrossfade =
        ghost !== null &&
        typeof current === 'string' &&
        current !== '' &&
        main.hidden === false &&
        this.reducedMotion() === false;

      if (!canCrossfade) {
        main.setAttribute('src', url);
        return;
      }

      this.galleryToken = this.galleryToken + 1;
      var token = this.galleryToken;
      var self = this;

      if (this.galleryTimer !== 0) {
        window.clearTimeout(this.galleryTimer);
        this.galleryTimer = 0;
      }

      ghost.setAttribute('src', current);
      ghost.removeAttribute('data-fade');
      ghost.hidden = false;

      main.setAttribute('src', url);

      var clear = function () {
        /* Ein neuer Wechsel hat das Overlay bereits uebernommen. */
        if (self.galleryToken !== token) return;
        ghost.hidden = true;
        ghost.removeAttribute('src');
        self.galleryTimer = 0;
      };

      var fadeOut = function () {
        if (self.galleryToken !== token) return;
        ghost.setAttribute('data-fade', '');
        self.galleryTimer = window.setTimeout(clear, 500);
      };

      if (typeof main.decode === 'function') {
        main.decode().then(fadeOut, function (error) {
          /* decode() bricht ab, wenn zwischenzeitlich ein anderes Bild gesetzt
             wurde. Das Overlay muss dann trotzdem weg. */
          warn('Galeriebild nicht dekodierbar, Crossfade uebersprungen: ' + error);
          clear();
        });
      } else {
        fadeOut();
      }
    }

    /** Ein Thumbnail neu zeichnen: Bild oder Platzhalter (kein innerHTML). */
    paintThumb(thumb, imageUrl, label) {
      while (thumb.firstChild !== null) thumb.removeChild(thumb.firstChild);

      if (imageUrl === null) {
        thumb.setAttribute('data-placeholder', '');
        var placeholder = document.createElement('span');
        placeholder.className = 'moonou-bundle-gallery__thumb-placeholder';
        placeholder.textContent = label;
        thumb.appendChild(placeholder);
        return;
      }

      thumb.removeAttribute('data-placeholder');
      var img = document.createElement('img');
      img.setAttribute('src', imageUrl);
      img.setAttribute('alt', label);
      img.setAttribute('width', '80');
      img.setAttribute('height', '80');
      img.setAttribute('loading', 'lazy');
      thumb.appendChild(img);
      thumb.setAttribute('aria-label', label);
    }

    /** Kartenpreise, GRATIS-Fahne und "Leuchte inklusive"-Hinweis. */
    renderCards(data) {
      var config = this.config;
      for (var i = 0; i < config.slots.length; i++) {
        var slotCfg = config.slots[i];
        var slotState = data.state.slots[i];
        var resolved = data.slots[i];

        var cards = this.querySelectorAll('[data-bundle-card][data-slot-index="' + slotCfg.index + '"]');
        for (var c = 0; c < cards.length; c++) {
          var card = cards[c];
          var handle = card.getAttribute('data-product-handle');
          var product = findProductByHandle(slotCfg.products, handle);
          if (product === null) continue;

          var priceEl = card.querySelector('[data-bundle-card-price]');
          var freeEl = card.querySelector('[data-bundle-card-free]');
          if (product.available === true) {
            /* Alle Karten zeigen denselben Farb-/Leuchtenstand wie der Slot,
               damit sie preislich vergleichbar bleiben (A1-Serverlogik). */
            var bulbValue = null;
            if (config.bulb.enabled && product.bulb_option_position > 0) {
              bulbValue = data.state.bulbOn ? product.bulb_on_value : product.bulb_off_value;
              if (bulbValue === '') bulbValue = null;
            }
            var variant = resolveVariant(product, slotState.color, bulbValue);
            /* Verfuegbarkeit AUF VARIANTENEBENE: die Karte darf nicht
               bepreist und wie waehlbar aussehen, wenn genau diese
               Farb-/Leuchten-Kombination ausverkauft ist. */
            var cardAvailable = variant !== null && variantAvailable(variant);
            if (priceEl !== null && variant !== null) {
              if (cardAvailable) {
                var cardPrice = variant.price;
                if (slotCfg.mode === 'lampshade_combo' && config.base !== null) {
                  cardPrice += config.base.price;
                }
                priceEl.textContent = money(cardPrice);
              } else {
                priceEl.textContent = TEXT_SOLD_OUT;
              }
            }
            /* v3.3 — Gratis-Slot: statt des Preises das GRATIS-Badge. Ist die
               Variante ausverkauft, tauschen die beiden die Rollen, damit
               "Ausverkauft" sichtbar bleibt. */
            if (slotCfg.hide_prices === true && freeEl !== null) {
              freeEl.hidden = !cardAvailable;
              if (priceEl !== null) priceEl.hidden = cardAvailable;
            }
            /* v3.3 — Karten-Thumbnail folgt der Farbe des Slots: waehlt der
               Kunde Olivgruen, zeigen ALLE Karten das olivgruene Varianten-
               bild. Ohne Variantenbild bleibt das Produktbild stehen. */
            this.swapCardImage(card, variant);
            this.markCardAvailability(card, cardAvailable);
          }

          var badge = card.querySelector('[data-bundle-gratis-badge]');
          if (badge !== null) {
            var isGratis = data.gratisSlotIndex === slotCfg.index &&
              resolved.ready === true &&
              resolved.product !== null &&
              resolved.product.handle === handle;
            badge.hidden = !isGratis;
          }

          this.renderCardNote(card, product);
        }
      }
    }

    /**
     * v3.3 — Kartenbild auf die Variante der aktuellen Slot-Farbe umstellen.
     * Idempotent (gleiche URL -> kein DOM-Schreiben, keine Animation), ohne
     * Layoutsprung (feste Hoehe + aspect-ratio) und mit kurzem Crossfade: das
     * neue Bild wird erst vorgeladen und dann getauscht, damit zwischendrin
     * keine leere Kachel steht.
     */
    swapCardImage(card, variant) {
      var img = card.querySelector('[data-bundle-card-image]');
      if (img === null) return;
      var next = variant !== null && typeof variant.image === 'string' && variant.image !== ''
        ? variant.image
        : img.getAttribute('data-fallback-src');
      if (next === null || next === '') return;
      if (img.getAttribute('src') === next) return;

      var pre = new Image();
      pre.onload = function () {
        img.setAttribute('src', next);
        /* Klasse abnehmen, Reflow erzwingen, neu setzen: sonst laeuft die
           Animation beim zweiten Farbwechsel nicht noch einmal. */
        img.classList.remove('is-swapping');
        void img.offsetWidth;
        img.classList.add('is-swapping');
      };
      pre.onerror = function () {
        warn('Kartenbild nicht ladbar: ' + next);
      };
      pre.src = next;
    }

    /**
     * Karte als (nicht) waehlbar markieren. Die Karte wird ausgegraut
     * (`data-unavailable` am <li>, Klasse `disabled` am Radio -> geteilte
     * Optik aus moonou-buybox.css).
     *
     * Der Radio bekommt `disabled` NUR, wenn das Produkt in KEINER Farbe
     * lieferbar ist (Serverzustand). Ist bloss die aktuelle Farb-/Leuchten-
     * Kombination ausverkauft, bleibt die Karte klickbar — sonst waere ein
     * Produkt, dessen andere Farbe sehr wohl lieferbar ist, unerreichbar.
     * Nach dem Klick springt syncColorRows() auf eine lieferbare Farbe.
     */
    markCardAvailability(card, available) {
      var item = card.closest('.moonou-variant-cards__item');
      if (item === null) {
        warn('Karte ohne Listenelement — Verfuegbarkeit nicht markierbar.');
        return;
      }
      if (available) {
        item.removeAttribute('data-unavailable');
      } else {
        item.setAttribute('data-unavailable', '');
      }
    }

    /** "Leuchte inklusive"-Hinweis (Babou-Fall), rein datengetrieben. */
    renderCardNote(card, product) {
      var note = card.querySelector('[data-bundle-card-note]');
      var included = this.config.bulb.enabled && bulbIsIncluded(product);
      if (!included) {
        if (note !== null) note.hidden = true;
        return;
      }
      if (note === null) {
        var bottom = card.querySelector('.moonou-variant-cards__card-bottom');
        if (bottom === null) return;
        note = document.createElement('span');
        note.className = 'moonou-bundle-config__card-note';
        note.setAttribute('data-bundle-card-note', '');
        note.textContent = 'Leuchte inklusive';
        bottom.appendChild(note);
      }
      note.hidden = false;
    }

    /** Beschriftung "Farbe: Rosa" der aktiven Swatch-Reihe. */
    renderColorLabels(data) {
      for (var i = 0; i < this.config.slots.length; i++) {
        var slotCfg = this.config.slots[i];
        if (slotCfg.show_color !== true) continue;
        var value = data.state.slots[i].color;
        var rows = this.querySelectorAll('[data-bundle-colors][data-slot-index="' + slotCfg.index + '"]');
        for (var r = 0; r < rows.length; r++) {
          /* Der Pflichtschritt-Zustand gehoert an JEDE Reihe, auch die
             versteckten: sonst startet eine spaeter eingeblendete Reihe ohne
             die orange Markierung. */
          if (value === null || value === '') {
            rows[r].setAttribute('data-color-pending', '');
          } else {
            rows[r].removeAttribute('data-color-pending');
          }
          if (rows[r].hidden) continue;
          var label = rows[r].querySelector('[data-bundle-color-label]');
          /* Ohne getroffene Farbwahl darf hier KEINE Farbe stehenbleiben —
             sonst behauptet die Zeile eine Auswahl, die es nicht gibt
             (Serverwert aus `slot_default_color`). */
          if (label !== null) label.textContent = value === null ? TEXT_PICK_COLOR : value;
        }
      }
    }

    /**
     * GRATIS-Box unter dem letzten Slot: was kommt ohne Aufpreis mit?
     * Zwei Zustaende im selben Kasten. Steht noch nicht jeder Gratis-Artikel
     * fest (Slot ohne Auswahl), gilt die Platzhalter-Zeile fuer die ganze
     * Box — eine halb gefuellte Liste waere schwerer zu lesen als ein Satz.
     */
    renderGratisBox(data) {
      if (this.gratisBoxEl === null || this.gratisListEl === null) return;

      var allResolved = data.autos.length > 0;
      for (var a = 0; a < data.autos.length; a++) {
        if (!data.autos[a].available) allResolved = false;
      }

      if (this.gratisPlaceholderEl !== null) this.gratisPlaceholderEl.hidden = allResolved;
      this.gratisListEl.hidden = !allResolved;
      if (!allResolved) return;

      for (var i = 0; i < data.autos.length; i++) {
        var auto = data.autos[i];
        var item = this.gratisListEl.querySelector('[data-bundle-gratis-item][data-auto-index="' + auto.index + '"]');
        if (item === null) continue;

        var name = item.querySelector('[data-bundle-gratis-name]');
        if (name !== null) {
          var label = this.autoDisplayName(auto);
          if (auto.quantity > 1) label = auto.quantity + '× ' + label;
          name.textContent = label;
        }

        var price = item.querySelector('[data-bundle-gratis-price]');
        if (price !== null) price.textContent = money(auto.price);

        var thumb = item.querySelector('[data-bundle-gratis-thumb]');
        if (thumb !== null) {
          if (typeof auto.image === 'string' && auto.image !== '') {
            thumb.setAttribute('src', auto.image);
            thumb.hidden = false;
          } else {
            thumb.removeAttribute('src');
            thumb.hidden = true;
          }
        }
      }
    }

    /**
     * Anzeigename eines Gratis-Artikels: Produktname ohne das ausgeblendete
     * Wort des Quell-Slots plus der Variantenwert ("Cora Weiß"). Der
     * Warenkorb-Titel bleibt davon unberuehrt — das hier ist reine Anzeige.
     */
    autoDisplayName(auto) {
      var cfg = null;
      for (var i = 0; i < this.config.auto_items.length; i++) {
        if (this.config.auto_items[i].index === auto.index) cfg = this.config.auto_items[i];
      }
      if (cfg === null) return auto.title;

      var base = auto.productTitle === '' ? auto.title : auto.productTitle;
      var slotCfg = null;
      if (cfg.mode === 'match_slot') {
        for (var s = 0; s < this.config.slots.length; s++) {
          if (this.config.slots[s].index === cfg.match_slot_index) slotCfg = this.config.slots[s];
        }
      }
      base = stripWord(base, slotCfg === null ? '' : slotCfg.title_remove);
      if (cfg.mode === 'match_slot' && cfg.match_variant_option !== '') {
        base = base + ' ' + cfg.match_variant_option;
      }
      return base;
    }

    renderTotals(data) {
      /* v3.1 — Kein "ab"-Preis und keine eingefrorene Referenz mehr. Der
         Preisblock rechnet IMMER mit einer vollstaendigen Kombination: fuer
         gewaehlte Slots mit der Wahl, fuer offene mit deren Standard
         (data.display, siehe computeDisplay). Ohne jede Auswahl kommt dabei
         exakt der Serverstand heraus (294,98 -> 244,99, -17 %), mit
         Teilauswahl bewegt sich der Preis sofort — auch beim Leuchten-Toggle.
         Eine reine Teilsumme waere irrefuehrend: sie zeigte den Preis EINER
         Lampe als Bundle-Preis. */
      var display = typeof data.display === 'object' && data.display !== null
        ? data.display
        : { total: data.total, compare: data.compareTotal, savings: data.savings };
      var total = display.total;
      var compare = display.compare;
      var savings = display.savings;

      this.totalEl.textContent = money(total);

      if (this.compareEl !== null) {
        var showCompare = compare > total;
        this.compareEl.hidden = !showCompare;
        this.compareEl.textContent = showCompare ? money(compare) : '';
      }

      if (this.percentEl !== null) {
        var percent = compare > 0 && savings > 0 ? Math.round((savings * 100) / compare) : 0;
        this.percentEl.hidden = percent <= 0;
        this.percentEl.textContent = percent > 0 ? '-' + percent + '%' : '';
      }

      /* v3.2 — Die "Du sparst X"-Zeile ist raus: Streichpreis, Preis und
         Prozent-Badge sagen dasselbe in zwei Zeilen statt in dreien. Der
         Ersparnisbetrag bleibt in der Rechnung, er wird nur nicht mehr
         eigenstaendig angezeigt. */

      if (this.noticeEl !== null) {
        var notices = data.notices.slice();
        if (this.discountNoticeText !== '') notices.push(this.discountNoticeText);
        this.noticeEl.textContent = '';
        if (notices.length === 0) {
          this.noticeEl.hidden = true;
        } else {
          this.noticeEl.hidden = false;
          this.noticeEl.appendChild(document.createTextNode(notices.join(' ')));
          if (this.discountRetry !== '') {
            this.noticeEl.appendChild(document.createTextNode(' '));
            var retry = document.createElement('button');
            retry.type = 'button';
            retry.className = 'moonou-bundle-config__retry';
            retry.setAttribute('data-bundle-discount-retry', '');
            retry.textContent = 'Erneut versuchen';
            this.noticeEl.appendChild(retry);
          }
        }
      }
    }

    renderCta(data) {
      var ready = data.ready && !this.busy;
      var labelReady = this.atcEl.getAttribute('data-label-ready');
      var labelIncomplete = this.atcEl.getAttribute('data-label-incomplete');
      if (labelReady === null) labelReady = this.config.cta_label;
      if (labelIncomplete === null) labelIncomplete = this.config.cta_label_incomplete;

      if (this.busy) return; /* Busy-Label setzt addToCart(). */

      var wasReady = this.ctaWasReady;
      this.ctaWasReady = ready;

      this.atcEl.textContent = data.ready ? labelReady : labelIncomplete;
      if (ready) {
        this.atcEl.removeAttribute('disabled');
        this.atcEl.removeAttribute('aria-disabled');
        /* Genau im Moment der Freischaltung ein leiser Impuls — nicht bei
           jedem Render und nicht beim ersten Aufbau der Seite. */
        if (wasReady === false) this.pulseCta();
      } else {
        this.atcEl.setAttribute('disabled', 'disabled');
        this.atcEl.setAttribute('aria-disabled', 'true');
      }
    }

    /** Einmaliger, leiser Impuls auf dem freigeschalteten CTA. */
    pulseCta() {
      if (this.reducedMotion()) return;
      if (typeof window.requestAnimationFrame !== 'function') return;
      var button = this.atcEl;
      button.removeAttribute('data-just-unlocked');
      window.requestAnimationFrame(function () {
        button.setAttribute('data-just-unlocked', '');
        window.setTimeout(function () {
          button.removeAttribute('data-just-unlocked');
        }, 500);
      });
    }

    /* ---------------------------------------------------------------- */
    /* Warenkorb                                                         */
    /* ---------------------------------------------------------------- */

    /**
     * items-Array in der Reihenfolge Slots -> auto_items -> Leuchtmittel.
     * `group` = null baut nur die Vorschau fuer das Change-Event (ohne
     * Properties), sonst haengen die `_bundle*`-Properties dran.
     */
    buildItems(data, group) {
      var items = [];
      var self = this;

      function push(variantId, quantity, role) {
        var item = { id: variantId, quantity: quantity };
        if (group !== null) {
          item.properties = {
            _bundle: self.config.bundle.handle,
            _bundle_title: self.config.bundle.title,
            _bundle_group: group,
            _bundle_role: role
          };
        }
        /* Identische Zeilen (z. B. 2x Sockel) zusammenfassen — Shopify
           wuerde sie sonst selbst mergen, was die Mengen verschleiert. */
        for (var i = 0; i < items.length; i++) {
          if (String(items[i].id) === String(variantId) &&
              JSON.stringify(items[i].properties) === JSON.stringify(item.properties)) {
            items[i].quantity += quantity;
            return;
          }
        }
        items.push(item);
      }

      for (var s = 0; s < data.slots.length; s++) {
        var slot = data.slots[s];
        if (!slot.ready) continue;
        var role = data.gratisSlotIndex === slot.index ? 'gratis' : 'component';
        for (var l = 0; l < slot.lines.length; l++) {
          /* Bei "lampshade_combo" bleibt der Sockel eine Komponente; die
             Gratis-Regel greift dort ohnehin nicht (nur "product"-Slots). */
          push(slot.lines[l].variant_id, slot.lines[l].quantity, role);
        }
      }

      for (var a = 0; a < data.autos.length; a++) {
        if (!data.autos[a].available) continue;
        push(data.autos[a].variant_id, data.autos[a].quantity, 'gratis');
      }

      if (data.bulbCount > 0 && this.config.bulb.extra !== null) {
        push(this.config.bulb.extra.variant_id, data.bulbCount, 'component');
      }

      return items;
    }

    newGroupId() {
      var random = Math.random().toString(36).slice(2, 6);
      return String(Date.now()) + '-' + random;
    }

    setBusy(busy, label) {
      this.busy = busy;
      if (busy) {
        this.atcEl.setAttribute('disabled', 'disabled');
        this.atcEl.setAttribute('aria-disabled', 'true');
        this.atcEl.setAttribute('aria-busy', 'true');
        if (typeof label === 'string') this.atcEl.textContent = label;
      } else {
        this.atcEl.removeAttribute('aria-busy');
      }
    }

    fetchConfig(type) {
      if (window.theme && theme.utils && typeof theme.utils.fetchConfig === 'function') {
        return theme.utils.fetchConfig(type);
      }
      warn('theme.utils.fetchConfig fehlt — eigener Request-Header-Satz.');
      return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/' + type }
      };
    }

    route(name, fallback) {
      if (window.theme && theme.routes && typeof theme.routes[name] === 'string' && theme.routes[name] !== '') {
        return theme.routes[name];
      }
      warn('theme.routes.' + name + ' fehlt — Fallback ' + fallback);
      return fallback;
    }

    /** Sections, die nach dem Cart-Call neu gerendert werden sollen. */
    bundledSections() {
      var sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } })
      );
      return sections;
    }

    addToCart() {
      if (this.busy) return;
      var data = this.compute();
      if (!data.ready) {
        warn('ATC ohne vollstaendige Auswahl — abgebrochen.');
        return;
      }

      var self = this;
      var group = this.newGroupId();
      var items = this.buildItems(data, group);
      if (items.length === 0) {
        warn('ATC ohne Zeilen — abgebrochen.');
        return;
      }

      this.setDiscountNotice('', '');
      this.setBusy(true, 'Wird hinzugefügt …');

      var sections = this.bundledSections();
      var config = this.fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        items: items,
        sections: sections.join(','),
        sections_url: window.location.pathname
      });

      fetch(this.route('cart_add_url', '/cart/add.js'), config)
        .then(function (response) { return response.json(); })
        .then(function (parsedState) {
          if (parsedState.status) {
            throw new Error(parsedState.description || parsedState.message || 'cart error');
          }
          self.lastGroup = group;
          return self.applyDiscount(false, sections, parsedState);
        })
        .catch(function (error) {
          /* /cart/add.js ist ATOMAR: eine einzige nicht bestellbare Zeile
             kippt das gesamte Bundle (422 "Cannot find variant"). Deshalb
             den Grund von Shopify mitzeigen statt nur "hat nicht geklappt". */
          warn('Warenkorb-Call fehlgeschlagen — nichts wurde hinzugefuegt.', error);
          var reason = '';
          if (error && typeof error.message === 'string' && error.message !== '') reason = ' (' + error.message + ')';
          self.setDiscountNotice('Das Bundle konnte nicht in den Warenkorb gelegt werden' + reason + '. Bitte prüfe deine Auswahl — möglicherweise ist eine Variante gerade ausverkauft.', 'atc');
        })
        .then(function () {
          self.setBusy(false);
          self.render();
        });
    }

    /** Hinweistext der Summary setzen. `retry` steuert den Retry-Button:
     *  nur dort, wo ein zweiter Versuch ueberhaupt etwas aendern kann. */
    setDiscountNotice(text, retryAction) {
      this.discountNoticeText = text;
      this.discountRetry = typeof retryAction === 'string' ? retryAction : '';
    }

    /** Codes an Shopify schicken; Antwort ist der komplette Warenkorb. */
    postDiscount(codes, sections) {
      var updateUrl = this.route('cart_update_url', '/cart/update.js');
      var updateConfig = this.fetchConfig('json');
      updateConfig.body = JSON.stringify({ discount: codes.join(','), sections: sections });
      return fetch(updateUrl, updateConfig).then(function (response) { return response.json(); });
    }

    /**
     * Rabattcode anwenden. Mechanik oben im Datei-Kopf belegt:
     * POST /cart/update.js mit { discount: "<codes>", sections: [...] }.
     * `retryOnly = true` wird vom Retry-Link in der Summary genutzt.
     *
     * WARUM NICHT EINFACH ANHAENGEN (Befund der Review vom 31.08.):
     * Bundle-Codes sind bewusst NICHT kombinierbar (Spec §5, "Kombinationen"
     * im Admin aus). Liegt schon irgendein Code im Warenkorb, kommt der
     * Bundle-Code mit `applicable:false` zurueck und der Rabatt faellt
     * KOMPLETT weg — gemessen: Warenkorb mit `5EUR` + `WOHNZIMMER-BUNDLE`
     * -> 5,00 € statt 49,99 € Rabatt. Ein nicht kombinierbarer Code wird
     * auch im Checkout nicht angewendet; "wird an der Kasse angewendet" war
     * also schlicht falsch. Deshalb: zweiter Versuch NUR mit dem Bundle-Code
     * (der Kunde hat gerade "Bundle in den Warenkorb" geklickt — das ist
     * seine juengste Entscheidung) und ehrliche Ansage, dass sein alter Code
     * dafuer entfernt wurde. Scheitert auch das, wird der Ausgangszustand
     * wiederhergestellt; der Kunde steht nie schlechter da als vorher.
     */
    applyDiscount(retryOnly, sections, addState) {
      var self = this;
      var code = this.getAttribute('data-discount-code');
      if (typeof code !== 'string') code = '';
      code = code.trim();

      if (typeof sections === 'undefined' || sections === null) sections = this.bundledSections();

      if (code === '') {
        /* Kein Code konfiguriert: nur den Warenkorb aktualisieren. */
        return this.refreshCart(addState, !retryOnly);
      }

      var cartUrl = this.route('cart_url', '/cart');
      var foreign = [];

      return fetch(cartUrl + '.js', { method: 'GET', headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cartJson) {
          if (cartJson.discount_codes instanceof Array) {
            for (var i = 0; i < cartJson.discount_codes.length; i++) {
              var existing = cartJson.discount_codes[i].code;
              if (typeof existing === 'string' && existing !== '' && existing.toUpperCase() !== code.toUpperCase()) {
                foreign.push(existing);
              }
            }
          }
          /* Erster Versuch: alles behalten. Klappt immer dann, wenn der Shop
             die Kombination doch erlaubt — dann bleibt der Kundencode drin. */
          return self.postDiscount(foreign.concat([code]), sections);
        })
        .then(function (parsedState) {
          if (discountApplied(parsedState, code)) {
            self.setDiscountNotice('', '');
            return parsedState;
          }

          if (foreign.length === 0) {
            warn('Rabattcode "' + code + '" wurde von Shopify nicht angewendet (applicable=false), obwohl kein anderer Code im Warenkorb lag. Warenkorb bleibt korrekt befuellt, aber OHNE Bundle-Rabatt.');
            self.setDiscountNotice('Der Bundle-Rabatt (Code ' + code + ') konnte nicht angewendet werden. Deine Artikel liegen im Warenkorb.', 'discount');
            return parsedState;
          }

          warn('Rabattcode "' + code + '" nicht angewendet — im Warenkorb liegt bereits [' + foreign.join(', ') + ']. Zweiter Versuch nur mit dem Bundle-Code.');
          return self.postDiscount([code], sections).then(function (secondState) {
            if (discountApplied(secondState, code)) {
              self.setDiscountNotice('Der Bundle-Rabatt ist aktiv. Dein Code ' + foreign.join(', ') + ' lässt sich nicht mit Bundles kombinieren und wurde dafür entfernt.', '');
              return secondState;
            }
            warn('Rabattcode "' + code + '" ist auch allein nicht anwendbar — vorheriger Zustand [' + foreign.join(', ') + '] wird wiederhergestellt.');
            return self.postDiscount(foreign, sections).then(function (restoredState) {
              self.setDiscountNotice('Der Bundle-Rabatt (Code ' + code + ') konnte nicht angewendet werden. Dein Code ' + foreign.join(', ') + ' bleibt aktiv.', 'discount');
              return restoredState;
            });
          });
        })
        .then(function (parsedState) {
          self.publishCart(parsedState);
          if (!retryOnly) self.openDrawer();
        })
        .catch(function (error) {
          warn('Rabatt-Anwendung fehlgeschlagen — Warenkorb bleibt ohne Bundle-Rabatt.', error);
          self.setDiscountNotice('Der Bundle-Rabatt (Code ' + code + ') konnte nicht angewendet werden. Deine Artikel liegen im Warenkorb.', 'discount');
          return self.refreshCart(addState, !retryOnly);
        })
        .then(function () {
          if (retryOnly) self.render();
        });
    }

    /** Warenkorb neu laden und Drawer-Sections publizieren (Gift-Picker-Muster). */
    refreshCart(addState, shouldOpenDrawer) {
      var self = this;
      var cartUrl = this.route('cart_url', '/cart');
      return fetch(cartUrl + '.js', { method: 'GET', headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cartJson) {
          if (addState && addState.sections) cartJson.sections = addState.sections;
          self.publishCart(cartJson);
          if (shouldOpenDrawer !== false) self.openDrawer();
        })
        .catch(function (error) {
          warn('Warenkorb konnte nicht neu geladen werden.', error);
        });
    }

    /**
     * cartUpdate publizieren. Die Abonnenten sind FREMDER Code (Theme-Drawer,
     * Apps) und laufen synchron. Wirft einer davon, darf das NICHT als
     * "Rabatt fehlgeschlagen" durchschlagen — deshalb eigener try/catch mit
     * eigener Meldung. Real beobachtet am 31.08.: `CartItems.onCartUpdate`
     * ruft `theme.a11y.trapFocus(miniCart, miniCart.querySelector(
     * '.horizontal-product__title'))`; enthaelt der Drawer NUR Bundle-Karten
     * (Paket B), gibt es diese Klasse nicht -> TypeError auf `null.focus()`.
     */
    publishCart(cartJson) {
      if (window.theme && theme.pubsub && typeof theme.pubsub.publish === 'function') {
        try {
          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
            source: 'moonou-bundle-configurator',
            cart: cartJson
          });
        } catch (error) {
          warn('Ein cartUpdate-Abonnent des Themes hat einen Fehler geworfen — Warenkorb ist trotzdem aktuell.', error);
        }
      } else {
        warn('theme.pubsub fehlt — Drawer wird nicht aktualisiert.');
      }
      try {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: cartJson } }));
      } catch (error) {
        warn('Ein ajaxProduct:added-Listener hat einen Fehler geworfen.', error);
      }
    }

    openDrawer() {
      var drawer = document.querySelector('cart-drawer');
      if (drawer !== null && typeof drawer.show === 'function') {
        /* Auch hier gilt: fremder Code. Ein Fehler beim Oeffnen darf den
           Rabatt-Status nicht verfaelschen. */
        try {
          drawer.show();
        } catch (error) {
          warn('Cart-Drawer konnte nicht geoeffnet werden — Warenkorb ist befuellt.', error);
        }
      } else {
        warn('Kein cart-drawer gefunden — Warenkorb wurde trotzdem befuellt.');
      }
    }
  }

  if (!customElements.get('moonou-bundle-configurator')) {
    customElements.define('moonou-bundle-configurator', BundleConfigurator);
  }
})();
